import Vue from 'vue';
import { gsap, Power2 } from 'gsap';
import SplitText from '../gsap-bonus/SplitText';
import 'intersection-observer';
import scrollama from 'scrollama';

Vue.component('text-split', {
    props: ['slide', 'nextClicked'],

    data() {
        return {
            split: null
        };
    },

    mounted() {
        this.setup();
    },

    methods: {
        setup() {
            this.splitLines();
            if(this.nextClicked == true) {
                gsap.fromTo(".split-line__inner", {translateY: '100%'}, {translateY: '0%', duration: 0.5, stagger: 0.1, delay: 0.5});
                gsap.fromTo(".slider-events-link__underline", { width: '0%', left: 0, right: 'auto'}, { width: '100%', duration: 0.5, delay: 0.5});
            } else {
                gsap.fromTo(".split-line__inner", {translateY: '-100%'}, {translateY: '0%', duration: 0.5, stagger: 0.1, delay: 0.5});
                gsap.fromTo(".slider-events-link__underline", { width: '0%', left: 'auto', right: 0}, { width: '100%', duration: 0.5, delay: 0.5});
            }
            
        },

        splitLines() {
            const selector = this.$refs.splittext;
            this.split = new SplitText(selector, {
                type: 'lines',
                linesClass: 'split-line'
            });

            for (let index = 0; index < this.split.lines.length; index++) {
                const line = this.split.lines[index];
                let inner = line.innerHTML;
                inner = `<div class="split-line__inner">${inner}</div>`;
                line.innerHTML = inner;
                line.style.overflow = 'hidden';
            }
        }
    },

    beforeDestroy() {
    }
});
